var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 7.8125C12 7.625 11.8125 7.4375 11.625 7.4375H8.5625V4.375C8.5625 4.1875 8.375 4 8.1875 4H7.8125C7.59375 4 7.4375 4.1875 7.4375 4.375V7.4375H4.375C4.15625 7.4375 4 7.625 4 7.8125V8.1875C4 8.40625 4.15625 8.5625 4.375 8.5625H7.4375V11.625C7.4375 11.8438 7.59375 12 7.8125 12H8.1875C8.375 12 8.5625 11.8438 8.5625 11.625V8.5625H11.625C11.8125 8.5625 12 8.40625 12 8.1875V7.8125ZM15.75 8C15.75 3.71875 12.2812 0.25 8 0.25C3.71875 0.25 0.25 3.71875 0.25 8C0.25 12.2812 3.71875 15.75 8 15.75C12.2812 15.75 15.75 12.2812 15.75 8ZM14.75 8C14.75 11.7188 11.7188 14.75 8 14.75C4.28125 14.75 1.25 11.75 1.25 8C1.25 4.3125 4.25 1.25 8 1.25C11.6875 1.25 14.75 4.28125 14.75 8Z","fill":"#444444"}));
}

Plus.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
